'use strict';

var getInnerText = require('./getInnerText');

function dangerouslyStripHTML(html) {
  var tmpEl = document.createElement('div');
  tmpEl.innerHTML = html || '';
  return getInnerText(tmpEl);
}

module.exports = dangerouslyStripHTML;


/** WEBPACK FOOTER **
 ** ./utils/dangerouslyStripHTML.js
 **/